import { Box, useTheme } from "@mui/material";
import type { Requirement } from "@/modules/zoom-calls/types";
import { buildRequirementChips } from "./extracted-fields.helpers";

const RequirementChips = ({ requirement }: { requirement: Requirement }) => {
  const theme = useTheme();
  const p = theme.nawy.colors.primitives;
  const chips = buildRequirementChips(requirement);
  if (chips.length === 0) return null;

  return (
    <Box sx={{ display: "flex", flexWrap: "wrap", gap: "6px" }}>
      {chips.map(({ Icon, label }, i) => (
        <Box
          key={`${label}-${i}`}
          component="span"
          sx={{
            display: "inline-flex",
            alignItems: "center",
            gap: "5px",
            px: "8px",
            py: "4px",
            borderRadius: "8px",
            // White pill on the grey requirement card (per Figma).
            backgroundColor: theme.nawy.colors.semantic.layer.primary,
            border: `1px solid ${p.navy[100]}`,
            color: p.navy[700],
            fontSize: 11,
            fontWeight: 500,
            whiteSpace: "nowrap",
          }}
        >
          <Icon size={12} />
          {label}
        </Box>
      ))}
    </Box>
  );
};

export default RequirementChips;
